module.exports = __webpack_public_path__ + "static/img/newsbanner.d6d61a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsbanner.jpg
// module id = 132
// module chunks = 2